import { PaymentsRequestModel } from "./PaymentRequestModel";


export class GiftcardRequest {
    customerCode: string;
    requests: Array<GiftcardRequestEntry>;
    paymentsRequestModel: PaymentsRequestModel;
    returnPaymentMethod: string;
    constructor() {
        this.customerCode = "";
        this.requests = [];
        this.paymentsRequestModel = new PaymentsRequestModel();
        this.returnPaymentMethod = "";
    }
}

export class GiftcardRequestEntry {

    giftCardNumber: string;
    amount: number;
    constructor(giftCardNumber: string,
        amount: number) {
        this.giftCardNumber = giftCardNumber;
        this.amount = amount;
    }
}